<template>
  <DashboardPanel panel-class="overview-stats">
    <div class="overview-grid">
      <article v-for="item in stats" :key="item.label" class="overview-item">
        <i :class="item.icon"></i>
        <span class="overview-item__label">{{ item.label }}</span>
        <strong>{{ item.value }}<small>{{ item.unit }}</small></strong>
        <span class="overview-item__trend">数据状态 <b :class="{ down: item.down }">{{ item.trend }}</b></span>
      </article>
    </div>
  </DashboardPanel>
</template>

<script>
import DashboardPanel from './DashboardPanel.vue'
import { formatNumber } from '../dashboardFormat'
export default {
  name: 'OverviewStats',
  components: { DashboardPanel },
  props: {
    data: { type: Object, default: () => ({}) },
    communityCount: { type: Number, default: 0 }
  },
  computed: {
    stats() {
      const rooms = this.data.rooms || {}
      const owners = this.data.owners || {}
      const repairs = this.data.repairs || {}
      return [
        { label: '在管小区数', value: this.format(this.communityCount), unit: '', trend: '实时', icon: 'el-icon-office-building' },
        { label: '房屋总数', value: this.format(rooms.totalRooms), unit: '户', trend: '实时', icon: 'el-icon-house' },
        { label: '业主总数', value: this.format(owners.totalOwners), unit: '户', trend: '实时', icon: 'el-icon-user' },
        { label: '当前工单数', value: this.format(repairs.openRepairs), unit: '单', trend: '实时', icon: 'el-icon-tickets', down: false }
      ]
    }
  },
  methods: {
    format(value) {
      return formatNumber(value)
    }
  }
}
</script>

<style lang="scss" scoped>
.overview-stats { height: 100%; }
.overview-grid { display: grid; grid-template-columns: repeat(4, 1fr); height: 100%; }
.overview-item { display: flex; align-items: center; flex-direction: column; justify-content: center; min-width: 0; border-right: 1px solid rgba(52, 112, 153, .18); }
.overview-item:last-child { border-right: 0; }
.overview-item > i { margin-bottom: 5px; color: #258df4; font-size: 29px; text-shadow: 0 0 10px rgba(24, 144, 255, .42); }
.overview-item__label { color: #c8d6e2; font-size: 13px; }
.overview-item strong { margin: 8px 0 6px; color: #f3f8fc; font-size: 23px; font-weight: 600; font-variant-numeric: tabular-nums; white-space: nowrap; }
.overview-item small { margin-left: 3px; color: #aebdca; font-size: 10px; font-weight: 400; }
.overview-item__trend { color: #869baa; font-size: 10px; white-space: nowrap; }
.overview-item__trend b { margin-left: 7px; color: #37c96c; font-weight: 500; }
.overview-item__trend b.down { color: #39ca67; }
</style>
